import apiClient from './api';

/**
 * 문의하기 폼 데이터를 서버에 전송
 * @param {Object} formData - 폼 데이터
 * @param {string} formData.title - 제목
 * @param {string} formData.content - 내용
 * @param {string} formData.phone - 휴대폰 번호
 * @param {string} formData.email - 이메일
 * @param {boolean} formData.isGuest - 게스트 여부 (비회원: true, 회원: false)
 * @returns {Promise} API 응답
 */
export const submitContactForm = async (formData) => {
  try {
    const requestData = {
      reportReason: '문의', // 필수 필드로 "문의"로 고정
      title: formData.title,
      content: formData.content,
      reportType: 'service', // 항상 'service'로 고정
      phone: formData.phone,
      email: formData.email,
      isGuest: formData.isGuest
    };

    const response = await apiClient.post('/service/report', requestData);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('문의하기 제출 에러:', error);
    
    // 에러 응답 처리
    if (error.response) {
      // 서버에서 응답을 받았지만 에러 상태코드
      return {
        success: false,
        error: {
          status: error.response.status,
          message: error.response.data?.message || '서버 에러가 발생했습니다.',
          errorCode: error.response.data?.errorCode || 'UNKNOWN_ERROR'
        }
      };
    } else if (error.request) {
      // 요청은 보냈지만 응답을 받지 못함
      return {
        success: false,
        error: {
          status: 0,
          message: '네트워크 연결을 확인해주세요.',
          errorCode: 'NETWORK_ERROR'
        }
      };
    } else {
      // 요청 설정 중 에러 발생
      return {
        success: false,
        error: {
          status: 0,
          message: '요청 처리 중 에러가 발생했습니다.',
          errorCode: 'REQUEST_ERROR'
        }
      };
    }
  }
}; 